import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../Store/actions";

export default (excludeRemaining, auditId) => {
    const { auditLocations } = useSelector((state) => state);
    const dispatch = useDispatch();

    useEffect(() => {
        const useAuditAssetLocations = async () => {
            if (excludeRemaining) {
                try {
                    const auditAuditLocations = auditLocations.data.filter(
                        (item) => item.audit.id === parseInt(auditId)
                    );
                    const locIds = auditAuditLocations.map((item) => item.id);
                    const data = await dispatch(
                        actions.auditAssets.create.selectRequest(
                            locIds,
                            "exclude"
                        )
                    );
                } catch (error) {}
            }
        };
        useAuditAssetLocations();
    }, [auditLocations]);
};
